import { useMemo } from 'react';
import { useInfiniteQuery } from 'react-query';
import { getBusinessProfileGroup } from '../../../apis/tms/folder.api';
import { convertArrayOfObject } from '../../../common/convert';
import { BUSINESS_PROFILE_GROUPS } from '../../../constant/QueryKeyName';
import { IPaginationMeta } from '../../../interfaces/common.interface';
import { IBusinessProfileGroup } from '../../../interfaces/profile.interface';

export default function useFetchBusinessProfileGroup({
  tmsUserId,
  pageSize,
}: {
  tmsUserId: string | undefined;
  pageSize: number;
}) {
  const queryReturn = useInfiniteQuery(
    [BUSINESS_PROFILE_GROUPS, pageSize, tmsUserId],
    getBusinessProfileGroup,
    {
      enabled: !!tmsUserId,
      refetchOnMount: true,
      getNextPageParam: (lastPage, _currentPages) =>
        lastPage?.hasNextPage ? lastPage?.currentPage + 1 : undefined,
    }
  );

  const data: { data: IBusinessProfileGroup[]; meta: IPaginationMeta } =
    useMemo(() => {
      if (!queryReturn.data) {
        return {
          data: [],
          meta: {
            currentPage: 0,
            totalPages: 0,
            totalCount: 0,
            pageSize: 0,
            hasPreviousPage: false,
            hasNextPage: false,
          },
        };
      }

      const queryPages = queryReturn.data.pages;

      const { data, ...meta } = queryPages[queryPages.length - 1];

      return {
        data: convertArrayOfObject(queryPages) as IBusinessProfileGroup[],
        meta,
      };
    }, [queryReturn.data]);

  return {
    data,
    queryReturn,
  };
}
